import { render, staticRenderFns } from "./productionVideos.vue?vue&type=template&id=4e61a1d9&"
import script from "./productionVideos.vue?vue&type=script&lang=js&"
export * from "./productionVideos.vue?vue&type=script&lang=js&"
import style0 from "./productionVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports